import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { BsPencil } from 'react-icons/bs'
import { MdOutlineMail } from "react-icons/md";
import { DateFormat } from '../../../../utils/DateFormat';
import CustomersService from '../../../../services/CustomersService';
import { toast, ToastContainer } from 'react-toastify';
import { MdAutorenew } from "react-icons/md";
import CreateUpdateProductModal from '../modals/CreateUpdateProductModal';
import { useForm } from 'react-hook-form';


const ListExpiredOrder = ({ products, loading, handleEdit, onSubmit }) => {
    const { register, handleSubmit, setValue, formState: { errors }, control, reset} = useForm();
    const today = new Date().toISOString().split('T')[0];
    const [emailLoadingId, setEmailLoadingId] = useState(null);
    const [showRenewalModal, setShowRenewalModal] = useState(false);
    const[product, setProduct] = useState({});

    const expiredOrders = products.filter(product =>
       product?.expiry_date && product.expiry_date.split('T')[0] < today
    );
    const sendEmail = async (id) => {
        setEmailLoadingId(id);
        try {
            const response = await CustomersService.sendEmail({id, type: 'expired'});
            if (response.status === 200) {
                toast.success(response?.data?.message);
            } else {
                toast.error(response?.data?.message || 'Failed to send email.');
            }
        } catch (error) {
            console.error("Error in sending email", error);
            toast.error(error?.response?.data?.message || error?.message || 'Error in sending email');
        } finally {
            setEmailLoadingId(null); // stop loader
        }
    };

    const renew = async (id, name) => {
        const productData = { value: id, label: name };
        setProduct(productData);
        setShowRenewalModal(true);
    }
    const onSubmitRenewal = async (data) => {
        onSubmit(data);
        setShowRenewalModal(false);
    }

    return (
        <>
            <table className="table table-sm table-hover table-nowrap card-table">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Product Name</th>
                        <th>Type</th>
                        <th>Product Type</th>
                        <th>Start Date</th>
                        <th>Expiry Date</th>
                        <th>Quantity</th>
                        <th>ID Code</th>
                        <th>In Stock</th>
                        <th>status</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {loading ? (
                        <tr>
                            <td colSpan="10" className="text-center">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </td>
                        </tr>
                    ) : expiredOrders.length > 0 ? (
                        expiredOrders.map((product) => (
                            <tr key={product.id}>
                                <td>{product.id}</td>
                                <td>{product.name}</td>
                                <td>{product.type}</td>
                                <td>{product.product_type}</td>
                                <td>{DateFormat(product.start_date)}</td>
                                <td>{DateFormat(product.expiry_date)}</td>
                                <td>{product.quantity}</td>
                                <td>{product.identification_code}</td>
                                <td>{product.in_stock ? 'Yes' : 'No'}</td>
                                <td>
                                    <span className={`badge ${product.expiry_date < today ? 'bg-danger' : 'bg-success'}`}>
                                        {product.expiry_date < today ? 'Expired' : 'Active'} { }
                                    </span>
                                </td>
                                <td>
                                    <Link to="#" onClick={() => handleEdit(product.id)}><BsPencil title="Edit" /></Link>
                                    {' | '}
                                    {emailLoadingId === product.id ? (
                                        <span className="spinner-border spinner-border-sm text-primary" role="status" />
                                    ) : (
                                        <Link to="#" onClick={() => sendEmail(product.id)}>
                                            <MdOutlineMail title="Send Email" />
                                        </Link>
                                    )}
                                    {' | '}
                                    <Link to="#" onClick={() => renew(product.product_id, product.name)}>
                                        <MdAutorenew title="Renew" />
                                    </Link>
                                </td>

                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="10" className="text-center">No expired orders found.</td>
                        </tr>
                    )}

                </tbody>
            </table>
            <ToastContainer />
            {showRenewalModal && (
                <CreateUpdateProductModal 
                show={showRenewalModal} 
                handleClose={() => setShowRenewalModal(false)}
                register={register}
                handleSubmit={handleSubmit}
                setValue={setValue}
                onSubmit={onSubmitRenewal}
                errors={errors}
                control={control}
                reset={reset}
                flag={'renewal'}
                productList={products}
                product={product}
                />
            )}
        </>
    )
}

export default ListExpiredOrder